<template>
	<section id="product-card" class="product-card">
		<div class="product-card__content-container">
			<h5 class="product-card__heading">Choose Your PC</h5>
			<prebuild-model-picker
				:prebuilds-list="prebuildsList"
				:current-prebuild-id="getCurrentPrebuildId"
				@select="setCurrentPrebuild"
			/>
			<case-color-picker
				:variants-list="variantsList"
				:current-variant-id="getCurrentVariantId"
				@select="setCurrentVariant"
			/>
			<PrebuildStars />
			<add-to-cart-button
				:price="getCurrentPrice"
				:current-variant-id="getCurrentVariantId"
				:current-variant="currentVariant"
				:shipping-info="shippingInfo"
			/>
		</div>
		<hr>
		<div class="product-card__content-container">
			<prebuild-fps :games-performance="gamesPerformance" />
		</div>
	</section>
</template>

<script>
import PrebuildModelPicker from "../../prebuild-model-picker";
import CaseColorPicker from "./case-color-picker";
import AddToCartButton from "./add-to-cart-button";
import PrebuildFps from "../../prebuild-fps";
import PrebuildStars from "./prebuild-stars";

export default {
	name: "ProductCard",
	components: {
		PrebuildModelPicker,
		CaseColorPicker,
		AddToCartButton,
		PrebuildFps,
		PrebuildStars
	},
	props: {
		prebuildsList: {
			type: Array,
			default() {
				return [];
			}
		},
		variantsList: {
			type: Array,
			default() {
				return [];
			}
		},
		gamesPerformance: {
			type: Object,
			default() {
				return {};
			}
		},
		currentVariant: {
			type: Object,
			default() {
				return {};
			}
		},
		currentPrebuild: {
			type: Object,
			default() {
				return {};
			}
		},
		shippingInfo: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	computed: {
		getCurrentPrice() {
			return this.currentVariant.price;
		},
		getCurrentPrebuildId() {
			return this.currentPrebuild.id;
		},
		getCurrentVariantId() {
			return this.currentVariant.id;
		}
	},
	methods: {
		setCurrentPrebuild(prebuild) {
			this.$emit("set-prebuild", prebuild);
		},
		setCurrentVariant(variant) {
			this.$emit("set-variant", variant);
		}
	}
};
</script>

<style lang="scss" scoped>
.product-card {
	margin: 0 -15px;
	background: #FFF;
	padding: 30px 15px;

	@media (min-width: 580px) and (max-width: 991px) {
		padding: 65px 0;
	}

	@media (min-width: 991px) {
		padding: 30px;
		transform: translateX(-15px);
	}

	&__content-container {
		@media (max-width: 991px) {
			max-width: 460px;
			margin: 0 auto;
		}
	}

	&__heading {
		margin: 0 0 20px;
		color: #444259;
		font-size: 16px;
		font-weight: bold;
		letter-spacing: 0;
		text-transform: uppercase;
	}

	.model-picker {
		margin-bottom: 30px;
	}

	hr {
		border-top: 1px solid #E3E3E3;
		margin: 0 -15px;

		@media (min-width: 991px) {
			margin: 0 -30px;
		}
	}
}

.product-card::v-deep {

	.model-picker {

		&__model:first-child {

			.model-picker__model__text {
				text-align: left;
				margin: 0;
			}

		}

		&__model:nth-child(2) {

			.model-picker__model__text {
				right: 8px;
			}

		}
	}

}
</style>
